import { DrawerBody, DrawerFooter } from '../Drawer.styles.js';
import { DrawerScreen, NavDrawerWrapper } from './NavDrawer.styles.js';
import { FocusScope } from '@react-aria/focus';
import { OverlayContainer } from '@react-aria/overlays';
import { forwardRef, type ReactNode, type Ref } from 'react';

type DrawerProps = {
  readonly children: ReactNode;
  readonly footerContent?: ReactNode;
  readonly isOpen: boolean;
  readonly onClose: () => void;
};

export const NavDrawer = forwardRef(
  (
    { children, footerContent, isOpen, ...drawerProps }: DrawerProps,
    ref: Ref<HTMLDivElement>,
  ) => {
    return (
      <OverlayContainer>
        <FocusScope
          autoFocus={isOpen}
          contain={isOpen}
          restoreFocus={isOpen}
        >
          <DrawerScreen isOpen={isOpen} />
          <NavDrawerWrapper
            isOpen={isOpen}
            ref={ref}
            {...drawerProps}
          >
            <DrawerBody>{children}</DrawerBody>
            {footerContent && <DrawerFooter>{footerContent}</DrawerFooter>}
          </NavDrawerWrapper>
        </FocusScope>
      </OverlayContainer>
    );
  },
);
